import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { isArray } from "util";
import { getUserSubscriptions } from "../modules/database";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    cart: [],
    user: null,
    subscriptions: [],
    currentDashboardSubscription: null,
    sideDrawer: true,
    planId: null,
    appSettings: {
      precision: 2,
      unit: "ft",
      logo: ""
    },
    defaultSettings: {},
    plans: [],
    storageAvailable: true,
    isPlanExpired: false
    // currentPaidSubscription: null
  },
  getters: {
    getCart: state => state.cart,
    getUser: state => state.user,
    getSubscriptions: state => state.subscriptions,
    areSubscriptionsInStore: state => {
      return state.subscriptions.length > 0;
    },
    getCurrentDashboardSubscription: state =>
      state.currentDashboardSubscription,
    getSideDrawer: state => state.sideDrawer,
    getPlanId: state => state.planId,
    getAppSettings: state => state.appSettings,
    getDefaultSettings: state => state.defaultSettings,
    getPlans: state => state.plans,
    getStorageStatus: state => state.storageAvailable,
    getPlanStatus: state => state.isPlanExpired
    // getCurrentPaidSubscription: state => state.currentPaidSubscription
  },
  mutations: {
    setPlanStatus(state, payload) {
      state.isPlanExpired = payload;
    },
    cleanSetting() {
      this.state.appSettings = null;
      this.state.defaultSettings = null;
      this.state.plans = [];
      this.state.storageAvailable = true;
      this.state.isPlanExpired = false;
    },
    updateStorageStatus(state, payload) {
      state.storageAvailable = payload;
    },
    updatePlans(state, payload) {
      state.plans = payload;
    },
    updateDefaultSettings(state, payload) {
      state.defaultSettings = payload;
    },
    updateAppSettings(state, payload) {
      state.appSettings = payload;
    },
    toggleSideDrawer(state, status) {
      if (status == true || status == false) {
        state.sideDrawer = status;
      } else {
        state.sideDrawer = !state.sideDrawer;
      }
    },
    updatePlanId(state, value) {
      state.planId = value;
    },
    updateCart(state, cartObject) {
      state.cart = cartObject.cart;
    },
    addToCart(state, productObject) {
      if (state.cart.length == 0) {
        state.cart.push(productObject.product);
      } else {
        state.cart[0] = productObject.product;
      }
    },
    emptyCart(state) {
      state.cart = [];
    },
    updateUser(state, userObject) {
      state.user = userObject.user;
    },
    clearAuth(state) {
      state.user = null;
    },
    updateUserStripeId(state, stripeId) {
      state.user.stripeId = stripeId;
    },
    updateSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    updateCurrentDashboardSubscription(state, currentDashboardSubscription) {
      state.currentDashboardSubscription = currentDashboardSubscription;
    },
    clearSubscriptions(state) {
      state.subscriptions = [];
    },
    clearCurrentDashboardSubscription(state) {
      state.currentDashboardSubscription = null;
    }
  },
  actions: {
    setPlanStatus({ commit }, payload) {
      commit("setPlanStatus", payload.status);
    },
    updateStorageStatus({ commit }, payload) {
      commit("updateStorageStatus", payload.status);
    },
    updatePlans({ commit }, payload) {
      commit("updatePlans", payload.plans);
    },
    cleanSetting({ commit }) {
      commit("cleanSetting");
    },
    updateDefaultSettings({ commit }, payload) {
      commit("updateDefaultSettings", payload.defaultSettings);
    },
    updateAppSettings({ commit }, payload) {
      commit("updateAppSettings", payload.appSettings);
    },
    updatePlanId({ commit }, value) {
      commit("updatePlanId", value);
    },
    toggleSideDrawer({ commit }, status) {
      commit("toggleSideDrawer", status);
    },
    addToCart({ commit }, product) {
      commit("addToCart", product);
    },
    emptyCart(context) {
      context.commit("emptyCart");
    },
    updateCart({ commit }, cart) {
      commit("updateCart", cart);
    },
    updateUser({ commit }, user) {
      commit("updateUser", user);
    },
    clearAuth(context) {
      context.commit("clearAuth");
    },
    updateUserStripeId({ commit }, stripeId) {
      commit("updateUserStripeId", stripeId);
    },
    async fetchUserSubscriptions({ state, dispatch }) {
      try {
        const list = await getUserSubscriptions();
        await dispatch("updateSubscriptions", list);
        return state.subscriptions;
      } catch (error) {
        throw error;
      }
    },
    updateSubscriptions({ commit, state, dispatch }, subscriptions = []) {
      if (isArray(subscriptions)) {
        if (subscriptions.length === 0) {
          //clearing subscriptions so clear
          dispatch("clearSubscriptions");
        } else if (subscriptions.length > 0) {
          // get CurrentDashboardSubscription id and find in subscriptions
          commit("updateSubscriptions", subscriptions);
          if (
            state.currentDashboardSubscription !== null &&
            state.currentDashboardSubscription !== undefined &&
            state.currentDashboardSubscription.id !== null
          ) {
            let matchedIndex = 0;
            let i = 0;
            for (i = 0; i < subscriptions.length; i++) {
              if (
                subscriptions[i].id === state.currentDashboardSubscription.id
              ) {
                matchedIndex = i;
                break;
              }
            }
            commit(
              "updateCurrentDashboardSubscription",
              subscriptions[matchedIndex]
            );
          } else {
            commit("updateCurrentDashboardSubscription", subscriptions[0]);
          }
        }
      }
    },
    updateCurrentDashboardSubscription(
      { commit },
      newDashboardSubscription = null
    ) {
      if (
        newDashboardSubscription !== null &&
        newDashboardSubscription.id !== undefined &&
        newDashboardSubscription.id !== null
      ) {
        commit("updateCurrentDashboardSubscription", newDashboardSubscription);
      }
    },
    updateCurrentDashboardSubscriptionId(
      { commit, state },
      newDashboardSubscriptionId = null
    ) {
      if (
        newDashboardSubscriptionId !== undefined &&
        newDashboardSubscriptionId !== null
      ) {
        //find subscription by id
        let matchedIndex = 0;
        let i = 0;
        for (i = 0; i < state.subscriptions.length; i++) {
          if (newDashboardSubscriptionId == state.subscriptions[i].id) {
            matchedIndex = i;
            break;
          }
        }
        commit(
          "updateCurrentDashboardSubscription",
          state.subscriptions[matchedIndex]
        );
      }
    },
    clearSubscriptions(context) {
      context.commit("clearSubscriptions");
      context.commit("clearCurrentDashboardSubscription");
    }
  },
  plugins: [createPersistedState()]
});
